export default {"src":"/_next/static/media/ten.8780c454.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};